(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('AttoDeleteController',AttoDeleteController);

    AttoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Atto'];

    function AttoDeleteController($uibModalInstance, entity, Atto) {
        var vm = this;

        vm.atto = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Atto.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
